<div>
  <div class="popup-content stresshead" [ngClass]="{'hidden': !showStressMeter }" >
    <div class="popup-header">
      <h2>{{audio.text.games.stresshead}}</h2>
    </div>

    <div>
      <h3 class="question long-question" [ngClass]="{'invisible': firstStressMeterDone }">{{measureText}}</h3>

      <div class="slider-wrapper">
        <h3>{{howStressed}}</h3>
        <p>({{audio.text.games.moveArrow}})</p>
        <input type="range" list="tickmarks" step="1" min="1" max="10" data-rangeslider #rangesliderReference>

        <datalist id="tickmarks">
          <option value="1" label="1">
          <option value="2" label="2">
          <option value="3" label="3">
          <option value="4" label="4">
          <option value="5" label="5">
          <option value="6" label="6">
          <option value="7" label="7">
          <option value="8" label="8">
          <option value="9" label="9">
          <option value="10" label="10">
        </datalist>
      </div>

      <div class="next-wrap">
        <div class="button green raised">
        <span class="button_text" (click)="finishStressMeter(); audio.playSoundClick();">Start</span>
      </div>
    </div>
  </div>
</div>

<div class="popup-content stressheadgame" *ngIf="!showStressMeter">
    <div class="popup-explanation">
      <h3 class="header">{{audio.text.games.instruction}}</h3>
      <p>{{explanationText}}
      </p>
    </div>

    <div class="popup-header">
      <h2>{{audio.text.games.stresshead}}</h2>
    </div>



      <div class="popup-inner-wrapper">
        <div class="left-side">
          <div class="answers stresshead">
            <span class="button answer" *ngFor="let answer of progressBarData" [ngClass]="{'raised':answer.pressed, 'down':!answer.pressed}" (click)="selectOption(answer);">{{options[answer.optionId].optionText.text}}</span>
          </div>
        </div>

        <div class="right-side" >
          <div class="emote-faces">
            <img class="emote" src="/img/popup/emotes/hoofd_{{angerLevel + 1}}.png" alt="stressed">
          </div>
          <div class="doneArea" [ngClass]="{'invisible': angerLevel !== 0}">
              <div class="next-wrap">
                  <h2>{{audio.text.games.wellDone}}</h2>
                  <div class="button green raised">
                  <span class="button_text" (click)="finishSelecting(); audio.playSoundClick();">{{audio.text.global.continue}}</span>
                </div>
              </div>
          </div>
        </div>


        <div class="clearfix"></div>

      </div>

  </div>
</div>
